import { createContext, useState } from "react";

const INITIAL_STATE = {
  returnLabel: 'Login',
  returnProject: null,
  returnPath: null
};

export const AccountCreationReturnContext = createContext();

const AccountCreationReturnContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <AccountCreationReturnContext.Provider value={stateHook}>
      {children}
    </AccountCreationReturnContext.Provider>
  );
};

export default AccountCreationReturnContextProvider;